<script>
  import { Hotel } from '@ctm/ui/Icons';
  import SectorStatusRow from './SectorStatusRow.svelte';

  export let sector;
</script>

<style>
  .icon {
    width: 100%;
    height: 100%;
  }
</style>

<SectorStatusRow iconType="hotel" status="{ sector.IsUnlimitedAllotment ? 'OnRequest' : sector.Status }">
  <div slot="icon" class="icon"><Hotel /></div>
  <div slot="title">{ sector.HotelName }</div>
  <div slot="desc">{ sector.Location.City }</div>
</SectorStatusRow>
